import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable} from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';
import { Design } from '../designTest/designTest.model';
import { DesignSet } from '../edit-questionset/edit-questionset.model';
import { Schedule } from '../scheduletest/scheduletest.model';
import { Evaluate } from '../evaluate_marks/evaluate.model';
import { Overall_Result } from '../overall_result/overall_result.model';
import { evaluate_user } from './endtest.service';

export interface QuestionSet {
    Question_Set_Name: string;
}
export interface collegequestionset{
  collegeid:string;
  yearid:string;
}
export interface GenerateSet {
  Question_Set_Id: string;
  Question_Set_Name: string;
}

interface TokenResponse {
  token: string;
}

export interface Pattern {
  pattern: string;
}

export interface evaluate {
  college_id: string;
  year_id: string;
  questionset_id: string;
}


export interface UserDetails {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  // confirmpassword: string;
  phone: string;
  type;
  exp: number;
  iat: number;
}

@Injectable()
export class QuestionSetService {

  private token: string;
  constructor(private http: HttpClient) {}
  private saveToken( token: string): void {
    localStorage.setItem('userToken', token);
    this.token = token;
  }

  private getToken(): string {
    if (!this.token) {
      this.token = localStorage.getItem('userToken');
      //
    }
    return this.token;
  }
  public getUserDetails(): UserDetails {
    const token = this.getToken();
    let payload;
    if (token) {
      //
      payload = token.split('.')[1];
      payload = window.atob(payload);
      return JSON.parse(payload);
    } else {
      return null;
    }
  }

  public isLoggedIn(): boolean {
    const user = this.getUserDetails();
    if (user) {
      return user.exp > Date.now() / 1000;
    } else {
      return false;
    }
  }
   // display questionset:
   public questionset(set: QuestionSet): Observable<any> {
    const base = this.http.post('/users/view_questionset', set);
    //
    const request = base.pipe(
      map((data: TokenResponse) => {


        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
  }

    // display college questionset.....................
    public college_questionset(set: collegequestionset ): Observable<any> {

      const base = this.http.post('/users/college/question_set_display', set);
      //
      const request = base.pipe(
        map((data: TokenResponse) => {


          // if (data.token) {
          //   this.saveToken(data.token);
          // }
          return data;
        })
      );
      return request;
    }

  // display questionset:

  // question_set_display.....
  public question_set_display(set: QuestionSet): Observable<any> {
    const base = this.http.post('/users/schedule/question_set_display', set);
    //
    const request = base.pipe(
      map((data: TokenResponse) => {


        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
  }



 // edit
 public edit(id): Observable<any> {

  var body = {
    id:id
  }
  const base = this.http.post('/users/edit_question_set', body);
  const request = base.pipe(
    map((data: TokenResponse) => {

      //
      if (data.token) {
        this.saveToken(data.token);
      }
      return data;
    })
  );
  return request;
}

// update
public update(set: Array<DesignSet>): Observable<any> {
  //
  // var body = {
  //   id:id
  // }


  const base = this.http.post('/users/update_question_set', set);
  const request = base.pipe(
    map((data: TokenResponse) => {

      //
      if (data.token) {
        this.saveToken(data.token);
      }
      return data;
    })
  );
  return request;
}


  // delete
  public delete(set: QuestionSet): Observable<any> {
       console.log(set,"this.set");
    const base = this.http.post('/users/view_questionset/delete', set);

    const request = base.pipe(
      map((data: TokenResponse) => {

        //
        if (data.token) {
          this.saveToken(data.token);
        }
        console.log("data",data)
        return data;
      })
    );
    return request;
  }

  // get_set_details
  public get_set_details(set: QuestionSet): Observable<any> {
   console.log("set",set)
    const base = this.http.post('/users/view_questionset/set_details', set);
    const request = base.pipe(
      map((data: TokenResponse) => {
        console.log("data**",data)
        return data;
      })
    );
    console.log("request",request);
    return request;
  }

 
  public get_set_configuration_details(set: QuestionSet): Observable<any> {

    const base = this.http.post('/users/view_questionset/configuration_details', set);
    const request = base.pipe(
      map((data: TokenResponse) => {
        
        return data;
        
      })
    );
    return request;
  }

  public get_set_config_details(set: QuestionSet): Observable<any> {

    const base = this.http.post('/users/clone/cloneqnsetconfig_details', set);
    const request = base.pipe(
      map((data: TokenResponse) => {
        console.log("dataconfig det",data)
        return data;

      })
    );
    return request;
  }


  //generateSet.....
  public generateSet(set: Array<DesignSet>): Observable<any> {
   console.log(set,"conset");
    const base = this.http.post('/users/question_set/generateSet', set);

    const request = base.pipe(
      map((data: TokenResponse) => {

        //
        if (data.token) {
          this.saveToken(data.token);
        }
        return data;
      })
    );
    return request;
  }

   //gettabledata....
   public gettabledata(set: Array<DesignSet>): Observable<any> {

    const base = this.http.post('/users/question_set/gettabledata', set);

    const request = base.pipe(
      map((data: TokenResponse) => {

        //
        if (data.token) {
          this.saveToken(data.token);
        }
        return data;
      })
    );
    return request;
  }

  public getsectionid(set: Array<DesignSet>): Observable<any> {

    const base = this.http.post('/users/question_set/getsectionid', set);

    const request = base.pipe(
      map((data: TokenResponse) => {

        //
        if (data.token) {
          this.saveToken(data.token);
        }
        return data;
      })
    );
    return request;
  }


// pattern
  public pattern(set: Pattern): Observable<any> {

    var body = {
      id: set
    };
    const base = this.http.post('/users/pattern', body);

    const request = base.pipe(
      map((data: TokenResponse) => {

        //
        if (data.token) {
          this.saveToken(data.token);
        }
        return data;
      })
    );
    return request;
  }

// schedule

public schedule(item: Array<Schedule>): Observable<any> {

  const b = this.http.post('/users/schedule', item);
  const request = b.pipe(
    map((data: TokenResponse) => {

      // if (data.token) {
      //   this.saveToken(data.token);
      // }
      return data;
    })
  );
  return request;
  }


  //update schedule

  public update_schedule(item: Array<Schedule>): Observable<any> {
         
    const b = this.http.post('/users/schedule/update', item);
    const request = b.pipe(
      map((data: TokenResponse) => {

        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        console.log("dataineditmodel",data)
        return data;
      })
    );
    return request;
    }



 // scheduledtest_view

 public scheduledtest_view(item: Array<Schedule>): Observable<any> {

  var body = {
    email: item
  };
  const b = this.http.post('/users/scheduledtest_view', body);
  const request = b.pipe(
    map((data: TokenResponse) => {
     console.log("datainscheduleview",data);
      return data;
    })
  );
  return request;
  }

  // scheduledtest_viewall.........
  public scheduledtest_viewall(item: Array<Schedule>): Observable<any> {
     console.log("item",item);
    var body = {
      email: item
    };
    const b = this.http.post('/users/view_schedule', body);
    const request = b.pipe(
      
      map((data: TokenResponse) => {
        console.log("datainscheduleviewall",data);
        console.log("data in edit model",data);
       return data;
   
      })
     
     
      
    );
    
    return request;
    }

  // delete_schedule
  public delete_schedule(item: Array<Schedule>): Observable<any> {
console.log("item",item)
    const base = this.http.post('/users/view_schedule/delete', item);
    console.log("item",item)
    const request = base.pipe(
      map((data: TokenResponse) => {

        //
        if (data.token) {
          this.saveToken(data.token);
        }
        return data;
      })
    );
    return request;
  }


  // evaluation_details
  public evaluation_details(item: Array<Evaluate>): Observable<any> {

    // var body = {
    //   email: item
    // };
    const b = this.http.post('/users/evaluation_details', item);
    const request = b.pipe(
      map((data: TokenResponse) => {

        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
    }

    // evaluate_marks
    public evaluate_marks(item: Array<Evaluate>): Observable<any> {

      // var body = {
      //   email: item
      // };
      const b = this.http.post('/users/evaluate_marks', item);
      const request = b.pipe(
        map((data: TokenResponse) => {

          // if (data.token) {
          //   this.saveToken(data.token);
          // }
          return data;
        })
      );
      return request;
      }

    //    // evaluate_all
    public evaluate_all(item:evaluate): Observable<any> {
      return this.http.post('/users/evaluate/evaluateall', item);
      }
    

      // overall_result
      public overall_result(item: Array<Overall_Result>): Observable<any> {

        // var body = {
        //   email: item
        // };
        const b = this.http.post('/users/overall_result', item);
        const request = b.pipe(
          map((data: TokenResponse) => {

            return data;
          })
        );
        return request;
        }

}



